import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import EDIconButton from '../../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDButton from '../../../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../../../BaseComponents/Icon/EDIcon';

interface IProps {
  open: boolean;
  onCloseButtonClick: () => void;
  onOpenButtonClick: () => void;
  onResetButtonClick: () => void;
  enabled: boolean;
  forceDisable?: boolean;
  unsavedAnalys: boolean;
  sideMenuOpen: boolean;
  pinned: boolean;
  togglePinned: () => void;
  disabledReason?: string;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      container: {
        display: 'flex',
        alignItems: 'center',
        padding: '24px 8px 8px 0px',
        '@media print': {
          display: 'none',
        },
      },
      containerOpen: {
        backgroundColor:
          theme.customProperties.EASideMenuColors.selectedOptionsSectionBGColor,
      },
      openCloseButton: {
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
        position: 'relative',
        bottom: 9.5,
      },
      buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
      },
      pinIcon: {
        padding: 8,
        position: 'absolute',
        top: 0,
        right: 0,
      },
    } as const)
);

/**
 * En toolbar för sidomenyn
 */
const EkonomiskAnalysSideMenuToolbar: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = ({
  open,
  onCloseButtonClick,
  onOpenButtonClick,
  onResetButtonClick,
  enabled,
  unsavedAnalys,
  sideMenuOpen,
  pinned,
  togglePinned,
  disabledReason,
  forceDisable,
}) => {
  const { classes, cx } = useStyles();
  return (
    <div
      className={cx(classes.container, {
        [classes.containerOpen]: sideMenuOpen,
      })}
    >
      <EDIconButton
        tooltip={open ? 'Stäng' : 'Öppna'}
        onClick={open ? onCloseButtonClick : onOpenButtonClick}
        icon={open ? 'chevron_left' : 'chevron_right'}
        className={classes.openCloseButton}
        disabled={forceDisable}
        disabledReason={
          forceDisable && disabledReason != null ? disabledReason : undefined
        }
      />
      <span className={classes.buttonContainer}>
        <EDButton
          icon={<EDIcon iconType="restore" color="inherit" />}
          label="Återställ analysmall"
          disabled={!enabled || unsavedAnalys || forceDisable}
          onClick={onResetButtonClick}
          labelNotUpperCase
          lowEmphasis
          flat
          primary
          captionLabel
        />
      </span>
      {sideMenuOpen && (
        <EDIconButton
          tooltip={pinned ? 'Lossa menyn' : 'Fäst menyn'}
          margin="dense"
          padding="none"
          className={cx(classes.pinIcon)}
          color="primary"
          onClick={togglePinned}
          icon={<EDIcon size="small" iconType={pinned ? 'pinOff' : 'pin'} />}
          disabled={forceDisable}
        />
      )}
    </div>
  );
};

export default EkonomiskAnalysSideMenuToolbar;
